import { StyleSheet } from 'react-native';
import colors from '@/config/colors';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  noSetsTitleText: {
    fontSize: theme.fontSizes.xl,
    fontWeight: '700',
    color: colors.newUI.therapist.grey60,
    marginBottom: theme.spacings.sm,
  },
  noSetsSubtitleText: {
    fontSize: theme.fontSizes.lg,
    fontWeight: '400',
    color: colors.newUI.therapist.grey60,
    marginBottom: theme.spacings.lg,
  },
  noSetsView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
